<div class="quote-step-adults">
  <lx-accommodation
    *ngIf="accommodations?.length"
    [accommodations]="accommodations"
    [accommodationOptional]="accommodationOptional"
    [moreAccommodationsDisclaimerShown]="moreAccommodationsDisclaimerShown"
  ></lx-accommodation>
  <lx-transfers [groupedTransfers]="groupedTransfers"></lx-transfers>
  <lx-insurance [insurance]="insurance"></lx-insurance>
  <lx-professional-immersion-experience [professionalImmersionExperience]="professionalImmersionExperience"></lx-professional-immersion-experience>
</div>
